// Service helper for Keap Partner 1:1 Link scheduling
export const DEFAULT_KICKOFF_CALL_LABEL = 'Onboarding Kickoff Call'

const KICKOFF_CALL_PRODUCTS = [
  {match: 'AEO & SEO', label: 'AEO & SEO'},
  {match: 'Thryv Leads', label: 'Leads'},
  {match: 'Social Ads', label: 'Social Ads'},
  {match: 'Thryv Social Posts', label: 'Thryv Social Posts'},
  {match: 'Marketing Center', label: 'Marketing Center'},
  {match: 'Workforce Center', label: 'Workforce Center'},
  {match: 'Thryv HVAC', label: 'Thryv HVAC'},
  {match: 'Business Center', label: 'Business Center'},
  {match: 'Keap', label: 'Keap'},
  {match: 'Professionally Designed Website', label: 'Website'},
]

const CENTER_KICKOFF_LABELS = [
  'Marketing Center',
  'Workforce Center',
  'Business Center',
]

export const getKickoffCallLabelFromCart = structuredCart => {
  if (!structuredCart) return DEFAULT_KICKOFF_CALL_LABEL

  const cartItems = [
    ...(structuredCart.centers || []),
    ...(structuredCart.apps || []),
    ...(structuredCart.oneTimeFees || []),
  ]

  const namesInCart = []
  const addName = value => {
    if (typeof value === 'string' && value.trim()) {
      namesInCart.push(value)
    }
  }

  cartItems.forEach(item => {
    if (!item) return

    addName(item.name)

    if (Array.isArray(item.addons)) {
      item.addons.forEach(addon => addName(addon?.name))
    }

    if (Array.isArray(item.entitlements)) {
      item.entitlements.forEach(entitlement => {
        if (typeof entitlement === 'string') {
          addName(entitlement)
        } else {
          addName(entitlement?.name)
        }
      })
    }
  })

  const selectedLabels = KICKOFF_CALL_PRODUCTS.filter(({match}) =>
    namesInCart.some(name => name.toLowerCase().includes(match.toLowerCase())),
  ).map(({label}) => label)

  const orderedSelectedLabels = [
    ...selectedLabels.filter(label => CENTER_KICKOFF_LABELS.includes(label)),
    ...selectedLabels.filter(label => !CENTER_KICKOFF_LABELS.includes(label)),
  ]

  if (!orderedSelectedLabels.length) return DEFAULT_KICKOFF_CALL_LABEL

  return `${orderedSelectedLabels.join(' / ')} Kickoff Call`
}

export const kP11LinkService = {
  async fetchAvailableTimeSlot(client, url) {
    try {
      const response = await client(url)
      return response
    } catch (error) {
      console.error('Error fetching available time slots:', error)
      throw error
    }
  },

  async confirmScheduleSlot(client, endpoint, data) {
    try {
      const response = await client(endpoint, {data, method: 'POST'})
      return response
    } catch (error) {
      console.error('Error confirming schedule slot:', error)
      throw error
    }
  },

  async captureAppoinmentDetail(client, url, data) {
    try {
      const response = await client(url, {data, method: 'POST'})
      return response
    } catch (error) {
      console.error('Error capturing appointment detail:', error)
      throw error
    }
  },
}
